import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

const dynamicYear = () =>{
    let currentYear = new Date();
    const displayYear = currentYear.getFullYear();
    return displayYear;
}

const Footer = () => {

    return (
        <footer className=' py-5 bg-dark text-white'>
            <Container>
                <Row>
                    <Col>
                        <div className="text-center">
                            <p>CopyRight {dynamicYear()} Gym Trainer Micheal</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;